export default __webpack_public_path__ + "static/media/khadamat.fe615a2a.svg";